import React, { useContext, useEffect, useState } from 'react'
import ModalCargando from '../utilsComponentes/ModalCargando';
import MsgUtils from '../Tools/MsgUtils';
import ItemCardSucursal from './ItemCardSucursal';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function ReporteVentaSucursal() {
    const {loading,setLoading} = useContext(ContextGloball);
    const [regional, setRegional] = useState('990');
    const [sucursales, setSucursales] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    function getSucursales() {
        setLoading(true);
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    setSucursales(data.ok)
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    useEffect(() => {
        getSucursales();
    }, [regional])
    return (
        <div>
            <div className='container-fluid bg-gradient bg-dark py-1'>
                <div className='btn-group'>
                <div className="input-group input-group-sm my-auto" style={{ width: '230px' }}>
                    <span className="input-group-text bg-secondary bg-gradient text-light" >Regional</span>
                    <select className=" form-select text-center "
                        value={regional} onChange={(e) => setRegional(e.target.value)}
                    >
                        <option value='990'>CBBA</option>
                        <option value='991'>SCRZ</option>
                    </select>
                </div>
                <button className='btn btn-success mx-2 btn-sm' onClick={() => setActualizar(!actualizar)}>Actualizar</button>
                </div>
            </div>
            <div className='container-fluid py-1'>
                <div className='row row-cols-1 row-cols-sm-1 row-cols-md-3 row-cols-xl-4 row-cols-xxl-4 g-1'>
                    {sucursales.map((item, index) => {
                        return (
                            <ItemCardSucursal sucursal={item} key={index} actualizar={actualizar} vista={'C'} />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default ReporteVentaSucursal